import {
  FetchEpisodeQuizzesParams,
  fetchEpisodeQuizzesRequest,
} from '@/requests';
import { Quiz } from '@/types';
import { camelCaseKeys } from '@/utils';

import { postgrestApi } from '../postgrest-api';
import { PostgrestApiTags } from '../store.constants';

export const quizzesApi = postgrestApi.injectEndpoints({
  endpoints: builder => ({
    fetchEpisodeQuizzes: builder.query<Quiz[], FetchEpisodeQuizzesParams>({
      query: fetchEpisodeQuizzesRequest,
      transformResponse: response =>
        camelCaseKeys<Quiz[]>(response).map(quiz => ({
          ...quiz,
          answers: quiz.answers.sort((a, b) => (a.id > b.id ? 1 : -1)),
        })),
      providesTags: [PostgrestApiTags.EPISODE_QUIZZES],
    }),
  }),
});

export const { useFetchEpisodeQuizzesQuery } = quizzesApi;
